// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Override
 */
export interface Override {
  /**
   * Unique identifier of the override.
   * @type {string}
   * @memberof Override
   */
  iD: string;
  /**
   * Billing account ID this override belongs to.
   * @type {string}
   * @memberof Override
   */
  billingAccountID: string;
  /**
   * When the override was created.
   * @type {Date}
   * @memberof Override
   */
  createdAt: Date;
  /**
   * User who created the override.
   * @type {string}
   * @memberof Override
   */
  createdBy: string;
  /**
   * Comment explaining the override.
   * @type {string}
   * @memberof Override
   */
  comment: string;
  /**
   * State of the override (e.g., active, deleted).
   * @type {string}
   * @memberof Override
   */
  state: string;
  /**
   * When the override was deleted (if applicable).
   * @type {Date}
   * @memberof Override
   */
  deletedAt?: Date;
  /**
   * User who deleted the override (if applicable).
   * @type {string}
   * @memberof Override
   */
  deletedBy?: string;
  /**
   * Reason for deletion (if applicable).
   * @type {string}
   * @memberof Override
   */
  deletionReason?: string;
}

/**
 * Check if a given object implements the Override interface.
 */
export function instanceOfOverride(value: object): value is Override {
  if (!('iD' in value) || value['iD'] === undefined) return false;
  if (!('billingAccountID' in value) || value['billingAccountID'] === undefined)
    return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('comment' in value) || value['comment'] === undefined) return false;
  if (!('state' in value) || value['state'] === undefined) return false;
  return true;
}

export function OverrideFromJSON(json: any): Override {
  return OverrideFromJSONTyped(json, false);
}

export function OverrideFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Override {
  if (json == null) {
    return json;
  }
  return {
    iD: json['ID'],
    billingAccountID: json['billingAccountID'],
    createdAt: new Date(json['createdAt']),
    createdBy: json['createdBy'],
    comment: json['comment'],
    state: json['state'],
    deletedAt:
      json['deletedAt'] == null ? undefined : new Date(json['deletedAt']),
    deletedBy: json['deletedBy'] == null ? undefined : json['deletedBy'],
    deletionReason:
      json['deletionReason'] == null ? undefined : json['deletionReason'],
  };
}

export function OverrideToJSON(json: any): Override {
  return OverrideToJSONTyped(json, false);
}

export function OverrideToJSONTyped(
  value?: Override | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ID: value['iD'],
    billingAccountID: value['billingAccountID'],
    createdAt: value['createdAt'].toISOString(),
    createdBy: value['createdBy'],
    comment: value['comment'],
    state: value['state'],
    deletedAt:
      value['deletedAt'] == null ? undefined : value['deletedAt'].toISOString(),
    deletedBy: value['deletedBy'],
    deletionReason: value['deletionReason'],
  };
}
